import { ISearchableAddress } from '@bca-shared/models/address';
import { IProduct } from '@bca-shared/models/product';
import { IUser } from '@bca-shared/models/user';
import { IAction } from '@bca-store/models/action';
import { ImageDialogState } from '@bca-user-data/models/_enums';
import { IFaceImage } from '@bca-user-data/models/face-image';
import { IMetric } from '@bca-user-data/models/metric';

export enum UserDataActionTypes {
  MiddleNamesLoading = '[UserData] MiddleNamesLoading',
  AddressLoading = '[UserData] AddressLoading',
  ImageUploading = '[UserData] ImageUploading',

  FetchMiddleNames = '[UserData] FetchMiddleNames',
  FetchAddress = '[UserData] FetchAddress',
  StartImageUpload = '[UserData] StartImageUpload',

  SetMiddleNames = '[UserData] SetMiddleNames',
  SelectUser = '[UserData] SelectUser',
  SaveImage = '[UserData] SaveImage',
  SelectProduct = '[UserData] SelectProduct',

  SetImage = '[UserData] SetImage',
  SetImageMetrics = '[UserData] SetImageMetrics',
  SetImageDialogState = '[UserData] SetImageDialogState',
  SetAuthorizedSavePermission = '[UserData] SetAuthorizedSavePermission',
  SetAddressManualMode = '[UserData] SetAddressManualMode',
  SetAddressSearchFailed = '[UserData] SetAddressSearchFailed'
}

export class SetImageDialogState implements IAction {
  readonly type = UserDataActionTypes.SetImageDialogState;
  constructor(public readonly payload: { state: ImageDialogState }) {}
}

export class ImageUploading implements IAction {
  readonly type = UserDataActionTypes.ImageUploading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export class SetAddressSearchFailed implements IAction {
  readonly type = UserDataActionTypes.SetAddressSearchFailed;
  constructor(public readonly payload: { failed: boolean }) {}
}

export class SetAuthorizedSavePermission implements IAction {
  readonly type = UserDataActionTypes.SetAuthorizedSavePermission;
  constructor(public readonly payload: { checked: boolean }) {}
}

export class SetAddressManualMode implements IAction {
  readonly type = UserDataActionTypes.SetAddressManualMode;
  constructor(
    public readonly payload: {
      productId: string;
      manual: boolean;
    }
  ) {}
}

export class StartImageUpload implements IAction {
  readonly type = UserDataActionTypes.StartImageUpload;
  constructor(public readonly payload: File) {}
}

export class SetImage implements IAction {
  readonly type = UserDataActionTypes.SetImage;
  constructor(public readonly payload: IFaceImage) {}
}

export class SaveImage implements IAction {
  readonly type = UserDataActionTypes.SaveImage;
}

export class SetImageMetrics implements IAction {
  readonly type = UserDataActionTypes.SetImageMetrics;
  constructor(public readonly payload: IMetric[]) {}
}

export class FetchMiddleNames implements IAction {
  readonly type = UserDataActionTypes.FetchMiddleNames;
}

export class SetMiddleNames implements IAction {
  readonly type = UserDataActionTypes.SetMiddleNames;
  constructor(public readonly payload: { middleNames: string[] }) {}
}

export class MiddleNamesLoading implements IAction {
  readonly type = UserDataActionTypes.MiddleNamesLoading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export class SelectUser implements IAction {
  readonly type = UserDataActionTypes.SelectUser;
  constructor(public readonly payload: IUser) {}
}

export class SelectProduct implements IAction {
  readonly type = UserDataActionTypes.SelectProduct;
  constructor(public readonly payload: IProduct) {}
}

export class FetchAddress implements IAction {
  readonly type = UserDataActionTypes.FetchAddress;
  constructor(public readonly payload: ISearchableAddress) {}
}

export class AddressLoading implements IAction {
  readonly type = UserDataActionTypes.AddressLoading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export type Action =
  | SelectProduct
  | SelectUser
  | FetchAddress
  | AddressLoading
  | FetchMiddleNames
  | SetMiddleNames
  | MiddleNamesLoading
  | ImageUploading
  | StartImageUpload
  | SetImage
  | SetImageMetrics
  | SetImageDialogState
  | SaveImage
  | SetAddressManualMode
  | SetAddressSearchFailed
  | SetAuthorizedSavePermission;
